<template>
  <!-- visit-finish -->
  <div class="vf">
    <div class="vf-panel">
      <img src="./img/bg-info.png" alt="信预约申请成功">
      <!-- <div class="vf-info">You have completed the registration process</div> -->
      <!-- <div class="vf-txt" v-if="!regSuccessedNotice">
        尊敬的{{userInfo.name || userInfo.nickName}}，您已成功登记“{{exhibitionInfo.exhibition.name}}”
      </div> -->
      <div class="vf-txt">
          {{regSuccessedNotice||'You have completed the registration process'}}
      </div>
      
      <div class="vf-award-btn" @click="goLogin">Back to sign in</div>
    </div>
    <!-- <div class="vf-link-box">
      <div class="vf-link" @click="myLinkToImgInviteBySingle()" v-if="false">
        <div class="vfl-logo s-one s-1">
        </div>
        <div class="vfl-content">
          <h4>邀请好友一起去</h4>
          <p>将展会观众预先注册链接直接发送给您的好友，邀请同去参观</p>
        </div>
      </div>
      <div class="vf-link" @click="myLinkToImgInvite()" v-if="false">
        <div class="vfl-logo s-one s-2">
        </div>
        <div class="vfl-content">
          <h4>发起多人组团参观</h4>
          <p>邀请多位买家一起注册参观，获得组委会的额外惊喜奖励</p>
        </div>
      </div>
      <div class="vf-link" @click="link('card')">
        <div class="vfl-logo s-one s-3">
        </div>
        <div class="vfl-content">
          <h4>查看我的参观证</h4>
          <p>这是您的专属电子入场证，请妥善保管，依据组委会规则使用</p>
        </div>
      </div>
      <div class="vf-link" @click="link('head')">
        <div class="vfl-logo s-one s-4">
        </div>
        <div class="vfl-content">
          <h4>了解展会信息</h4>
          <p>获得更多关于展商，展品，活动的相关咨询和信息</p>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import gql from 'graphql-tag'

export default {
  // 注册成功页面
  data() {
    return {
      CardId: "",
      VisitorRegRemind:null, // 自定义注册完成描述
    };
  },
  computed: {
    ...mapGetters({
      userInfo:'getUserInfo',
      exhibitionId:'getExhibitionId',
      exhibitionInfo:'getExhibitionInfo',
      exhibitionConfig:"getExhibitionConfig",
    }),
    regSuccessedNotice(){
      if(this.exhibitionConfig && this.exhibitionConfig.visitorReg && this.exhibitionConfig.visitorReg.regSuccessedNoticeEn){
        return this.exhibitionConfig.visitorReg.regSuccessedNoticeEn
      } else {
        return  false
      }
    },
    Notice(){
      if(this.regSuccessedNotice){
          let word = this.regSuccessedNotice.replace(/(【条码】)/g,`${this.CardId}`);
          return  word;
      } else {
        return ''
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    let hasHistory = true;
    if (!from.name && from.matched.length === 0) {
      hasHistory = false;
    }
    next(vm => (vm.hasHistory = hasHistory));
  },
  async created() {
    await this.$Myapollo.getUserInfo(this);
    await this.$Myapollo.getExhibitionInfo(this, this.exhibitionId,this.userInfo.userId)
    console.log(this.exhibitionConfig,'展会')
    // this.getCard();
  },
  methods: {
    ...mapActions({
      LinkFooter: "linkTo/LinkFooter",
      LinkToMyPapers:"linkTo/LinkToMyPapers",
      LinkToLogin:"linkTo/LinkToLogin"
    }),
    getCard(){
      let query=gql `query
      getMemberCertificate($exhibitionId: Guid!,$userId: String!,$type:MemberCertificateTypes){
          getMemberCertificate(exhibitionId:$exhibitionId,userId:$userId,type:$type){
            code
            id
            typeId
            userId
          }
      }`;
      this.$apollo.addSmartQuery("getMemberCertificate",{ 
        query:query,
        variables:{
          exhibitionId:this.exhibitionId,
          userId:this.userInfo.userId,
          type:"ExhibitionVisitor"
        },
        fetchPolicy: 'network-only',    //清理缓存
        result(data){
          let res=JSON.parse(JSON.stringify(data.data.getMemberCertificate));
          if(res){
            this.CardId = res.code;
          }
        },
        error(err){
          console.log('err',err)
        }
      })
    },
    link(type){
      switch(type){
        case 'home' :
          var opt = {
            url: `/home/${this.exhibitionId}`,
          };
          this.LinkFooter(opt);
          break;
        case 'card' :
          this.LinkToMyPapers();
          break;
        case 'head' :
          this.$store.commit('setHeadTab','exinfo')
          var req = {
            url: `/news/${this.exhibitionId}`,
          };
          this.LinkFooter(req);
          break;
      }
    },
    goLogin(){
      this.$router.push({path: `/signIn/${this.exhibitionId}`})
    }
  }
};
</script>

<style lang="scss" scoped>
.vf {
  &-link-box {
    background: #fff;
    padding: 0 15px;
  }
  &-link {
    display: flex;
    padding: 15px 0;
    border-bottom: 1px solid #e6e6e6;
    position: relative;
    &:last-child {
      border-bottom-color: transparent;
    }
    &::after {
        content: "";
        font-size: 14px;
        width: 6px;
        height: 6px;
        border: 1px solid #c7c7cc;
        border-width: 1px 1px 0 0;
        transform: rotate(45deg);
        position: absolute;
        right: 0;
        top:48%;
    }
    .vfl {
      &-logo {
        // background-color: #fff;
        // box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.1);
        // border-radius: 5px;
        // display: flex;
        // justify-content: space-between;
        &.s-one {
          width: 75px;
          height: 80px;
          color: #fff;
          font-size: 11px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          position: relative;
          background-size: contain;
          background-repeat: no-repeat;
          span {
            display: block;
            text-align: center;
          }
          .icon {
            font-size: 30px;
          }
          &.s-1 {
            background-image: url("./img/s1.png");
          }
          &.s-2 {
            background-image: url("./img/s2.png");
          }
          &.s-3 {
            background-image: url("./img/s3.png");
          }
          &.s-4 {
            background-image: url("./img/s4.png");
          }
        }
      }
      &-content {
        flex: 1;
        padding-left: 11px;
        padding-right: 34px;
        width: calc(100% - 75px);
        h4 {
          font-size: 16px;
          color: #333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 4px 0 6px;
          font-weight: bold;
        }
        p {
          font-size: 13px;
          color: #666;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 1.6;
        }
      }
    }
  }
  &-panel {
    text-align: center;
    background: #fff;
    padding: 36px 0 30px;
    // margin-bottom: 12px;
    // border-bottom: 10px solid #f5f5f5;
    img {
      width: 75px;
      display: inline-block;
      margin-bottom: 15px;
    }
  }
  &-info {
    font-size: 20px;
    line-height: 24px;
    color: #0290fe;
    margin-bottom: 17px;
  }
  &-txt {
    font-size: 14px;
    line-height: 24px;
    color: #999;
    margin-bottom: 25px;
    width: 76%;
    margin: 0 auto;
  }
  &-btn {
    width: 180px;
    line-height: 35px;
    background-color: #0290fe;
    border-radius: 3px;
    color: #fff;
    margin: 0 auto 12px;
    font-size: 15px;
  }
  &-award {
    padding: 10px 15px;
    background: #fff;
    display: flex;
    align-items: center;
    img {
      width: 75px;
      height: 50px;
    }
    &-txt {
      padding: 0 11px;
      font-size: 15px;
      color: #333;
      flex: 1;
    }
    &-btn {
      width: 3.5rem;
      height: .92rem;
      text-align: center;
      line-height: .92rem;
      border-radius: 3px;
      border: solid 1px #1890ff;
      color: #1890ff;
      font-size: .36rem;
      margin: .6rem auto 0;
    }
  }
}
</style>